export interface IWebConfig {
  apiUrl: string;
  online: string;
  edmUrl: string;
  backend: string;
  AIOpenDay: Record<string, string>;
  appId: number | null;
}

const apiConfig = {
  development: {
    apiUrl: 'https://dts-dev-i.bmw.com.cn/backend',
    // apiUrl: 'http://localhost:8081/backend',
    // apiUrl: 'http://10.195.170.146:8081/backend',
    // apiUrl: 'http://172.20.10.10:8081/backend',
    online: 'https://dts-uat.bmw.com.cn',
    edmUrl: ['https://', 'edm-dev.bmw.com.cn'].join(''),
    backend: 'https://dts-dev.bmw.com.cn/ht/',
    AIOpenDay: {
      News2024: '1420762247192576',
    },
    ossStatic: 'https://dts-dev.bmw.com.cn/__statics/',
    ossBackendStatic: 'https://dts-dev.bmw.com.cn/backend/',
    appId: null,
  },
  test: {
    apiUrl: 'https://dts-uat-i.bmw.com.cn/backend',
    online: 'https://dts-uat.bmw.com.cn',
    edmUrl: 'https://edm-test.bmw.com.cn',
    backend: 'https://dts-uat.bmw.com.cn/ht/',
    AIOpenDay: {
      News2024: '1424376745385984',
    },
    ossStatic: 'https://dts-uat.bmw.com.cn/__statics/',

    ossBackendStatic: 'https://dts-uat.bmw.com.cn/backend/',
    appId: 603,
  },
  prd: {
    apiUrl: 'https://dts-prod-i.bmw.com.cn/backend',
    online: 'https://dts.bmw.com.cn',
    edmUrl: 'https://edm.bmw.com.cn',
    backend: 'https://dts.bmw.com.cn/ht/',
    AIOpenDay: {
      News2024: '1424515071066112',
    },
    ossStatic: 'https://dts.bmw.com.cn/__statics/',

    ossBackendStatic: 'https://dts.bmw.com.cn/backend/',
    appId: 668,
  },
  api: {
    apiUrl: 'https://dts-dev-i.bmw.com.cn/backend',
    // apiUrl: 'https://dts-uat-i.bmw.com.cn/backend',
    online: 'https://dts-uat.com.cn',
    edmUrl: ['http://', 'edm-dev.bmw.com.cn'].join(''),
    backend: 'https://dts-dev.bmw.com.cn/ht/',
    AIOpenDay: {
      News2024: '1424376745385984',
    },
    ossStatic: 'https://dts-dev.bmw.com.cn/__statics/',
    ossBackendStatic: 'https://dts-dev.bmw.com.cn/backend/',
    appId: null,
  },
};

const mode = import.meta.env.MODE as keyof typeof apiConfig;

const webConfig: IWebConfig = apiConfig[mode];

/**
 * oss地址:
 * https://oss.console.aliyun.com/bucket/oss-cn-beijing/dts-prod/object?path=statics%2F
 * @param url
 * @returns
 */
export const genStaticUrl = (url: string, checkEnv = false) => {
  if (checkEnv) {
    return `${apiConfig[mode].ossStatic}${url || ''}`;
  }
  return `https://dts.bmw.com.cn/__statics/${url || ''}`;
};

export const genBackgroundStaticUrl = (url: string) =>
  `${apiConfig[mode].ossBackendStatic}${url || ''}`;

export const genProdBackgroundStaticUrl = (url: string) =>
  `https://dts.bmw.com.cn/backend/${url || ''}`;

//@ts-ignore
window[webConfig] = webConfig;
export default webConfig;
